// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3d1uf","sendOtp":"AuthorizeToLogin_sendOtp__2Jajs"};